import RadioTabs from './RadioTabs';

export default RadioTabs;
